// frontend/src/context/AuthContext.js
import axios from "axios";
import React, { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BaseUrlContext } from "../context/BaseUrlContext";

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const { BaseUrl } = useContext(BaseUrlContext);
  // const [token, setToken] = useState(null);
  const [tokenKey, setTokenKey] = useState(localStorage.getItem("tokenKey") || "");
  const [userName, setUserName] = useState();
  const [userPassword, setUserPassword] = useState();
  const [error, setError] = useState("");
  const [reports, setReports] = useState();
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const navigate = useNavigate();

  // useEffect(() => {
  //   const saved = localStorage.getItem("auth");
  //   if (saved) {
  //     const obj = JSON.parse(saved);
  //     setUser(obj.user);
  //     setToken(obj.token);
  //   }
  // }, []);
  // ............................................................................................
  const fetchLoginUserReports = async(token) => {
    try{
    //  console.log(token, "token12");
    if (!token) {
      navigate("/");
      return;
    }
    const res= await axios.get(`${BaseUrl}api/auth/get-user-reports`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    // console.log(res.data, "Response Data1243");
    setReports(res.data);
    return res.data;
    }
    catch (error) {
      if (error.response && error.response.status === 401) {
        setAlert({ show: true, type: "danger ", message: "Unauthorized: Invalid credentials" });
      }
      else {
        setAlert({ show: true, type: "danger ", message: "Login failed. Please check your network or try again." });
      }
    }
  }
  // ............................................................................................
    const handleLogin = async (e) => {
    e.preventDefault();
    try{
      const response = await axios.post(`${BaseUrl}api/auth/user-login`, {userName: userName,userPassword: userPassword});
      if(response.status === 200){
        const token = response.data;
        // console.log(response.data, "token2");
        setTokenKey(response.data);
        localStorage.setItem("tokenKey",token);
        const loginUserReports = await fetchLoginUserReports(token);
        // console.log(token, "loginUserReports");
        if(loginUserReports){
          setAlert({ show: true, type: "success", message: "Login Successfully" });
          const redirectTo = `/dashboard`;
          window.location.href = redirectTo;
        }
        else {
          setError({ show: true, type: "danger ", message: "Login failed. Please check your network or try again." });          
        }
      }
       else {
        setError({ show: true, type: "danger ", message: "Invalid username or password!" });
      }
      
    }
    catch (error) {
      // console.error("Login error:", error.response?.data || error.message);

      if (error.response && error.response.status === 401) {
  setError("Invalid username or password.");
} else if (error.response && error.response.status === 500) {
  setError("Server error. Please try again later.");
} else {
  setError("Login failed. Please check your network or try again.");
}
    }
  };
  // const login = (userObj, tokenStr) => {
  //   setUser(userObj);
  //   setToken(tokenStr);
  //   localStorage.setItem("auth", JSON.stringify({ user: userObj, token: tokenStr }));
  // };

  const logout = () => {
    // setUser(null);
    setTokenKey(null);
    localStorage.removeItem("auth");
    localStorage.removeItem("tokenKey");
    navigate("/");
  };

  return (
    <LoginContext.Provider value={{ 
      tokenKey,
      setTokenKey, 
      userName,
      setUserName,
      userPassword,
      setUserPassword,
      error,
      setError,
      reports,
      setReports,
      alert,
      setAlert,
      fetchLoginUserReports,
      logout,
      handleLogin
       }}>
      {children}
    </LoginContext.Provider>
  );
};
